<template>
  <div>

    <section  class="navbarsection" style="margin-top: -50px;">
      <div class="txtdata">
        <h1  style="padding-top: 200px;"></h1>
      </div>
        <div class="videosection" >
          <div  v-show="pvisvideo === true && pvpictureimage === false ">
            <Transition class="transition thing">
              <video-background 
                playbackRate=0.2
                :src="src"
                :poster="poster"
                :class="`thing playercss`"
                :style="`height: 600px;`">
              </video-background>
            </Transition>
          </div>
        
            <div id="panorama"  v-show="pvisvideo === false && pvpictureimage === true"  :style="`height: 600px; padding-top: -5px;`">
            </div>
  
            <img :src="poster" style="width: 100%; height: 600px;" class="imgcss" 
            v-show="pvisvideo === false && pvpictureimage === false || pvisvideo === true && pvpictureimage === true" />
   
      </div>
      <div class="overlay"></div>
      <div style="margin-top: -200px; color: white; margin-left: 50px; margin-bottom: 300px;">
        <h1 class="" v-html="imagetext" :class="formatvhtml"></h1>
      </div>
    </section>

 <div class="seven3css">
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-8">

       <div v-html="sustsec1text"></div>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-4">
      <div class="card shadow pushsection">
        <div v-html="susthighlight"></div>
        <canvas id="myChart" class="@-moz-document url-prefix()"></canvas>
      </div>
    </div>
  </div>
 </div>
 <!-- <div class="formatsdgs">
  <AllSdgs :getallgoalsmapping="sdgsmappingsinfo" :getallsdgslisting="sdgslistinginfo" carddivtheme="carddivcss"/>
</div>
  <div class="allreports">
    <AllReports :lastrecordsreportpresent="lastrecordsreportpresent" :reportpresentation="reportpresentation" 
    :openpdf="openpdf" :singlereporttitle="singlereporttitle" :rptfulltext="rptfulltext" 
    :rpcoverpageimagepath="rpcoverpageimagepath" :rplinkname="rplinkname" 
    :bgimage="bgimage" :showbg="showbg" :showrptfulltext="showrpttext"
    />
  </div> -->


  <div style="padding: 100px;">
    <hr />
    <div v-html="bottomtext" style="text-align: center;">
    
    </div>
  </div>

  </div>
</template>

<script>

import SeventyThirtysection from '@/components/SeventyThirtysection.vue';
import AllReports from '@/components/AllReports.vue';
import AllCardsext from '@/components/AllCardsext.vue';
import AllSdgs from '@/components/AllSdgs.vue';
import BreadCrumbs from '@/components/BreadCrumbs.vue';
require('@/assets/css/pannellium-2.5.css');
require('@/assets/css/video-js.css');
require('@/globalDeclare.js');
import Chart from 'chart.js/auto';
import axios from 'axios';


export default {
  name: 'AboutView',
  components: {
 SeventyThirtysection, AllReports, AllCardsext, AllSdgs, BreadCrumbs
},
data() {
  return {
  videoimage: [],
  imagetext: '',
  src: '',
  playrate: '',
  poster: '',
  pvwebm: '',
  pvmp4: '',
  pvstyle: '',
  pvsrc: '',
  pvisvideo: false,
  pvpanorama1: '',
  pvpanorama2: '',
  pvpanorama3: '',
  pvhotspot1: '',
  pvhotspot2: '',
  pvhotspot3: '',
  showVideo: false,
  showPanorama: false,


  // corpgovernpolicy: [],
  sustsec1text: '',
  susthighlight: '',
  bottomtext: '',

  // SliderData: [],
  bgimage: '',
  showrpttext: false,
  showbg: false,

  newsphoto: '',

  reportpresentation: [],
  lastrecordsreportpresent: [],
  myPicUrl: '',

  sdgsmappingsinfo: [],
  sdgslistinginfo: [],

  gcolorcodes: [],
  breadcrumbsinfo: [],

  height: 0,
  width: 0,
  }
},
methods: {

},
async mounted() {
  this.myPicUrl = myUrlPath
await axios.get('allpagespv/climatechange').then(
  response => {
      this.videoimage = response.data
      
      this.imagetext = this.videoimage.pvdisplaytext 
      this.src = this.videoimage.pvsrc
      this.playrate = this.videoimage.playbackrate
      this.poster = this.videoimage.pvposter
      this.pvstyle = this.videoimage.pvstyle
      this.pvisvideo = this.videoimage.pvisvideo
      this.pvpanorama1 = this.videoimage.pvpanorama1
      this.pvpanorama2 = this.videoimage.pvpanorama2
      this.pvpanorama3 = this.videoimage.pvpanorama3
      this.pvhotspot1 = this.videoimage.pvhotspot1
      this.pvhotspot2 = this.videoimage.pvhotspot2
      this.pvhotspot3 = this.videoimage.pvhotspot3
      this.pvpictureimage = this.videoimage.pvpictureimage

       if (this.pvisvideo === true) {
          this.src = this.videoimage.pvsrc
        }
        else {
            const config = {
            autoLoad: true,
            scenchange: true,
            compass: false,
            northOffset: -20.5,
            default: {
                firstScene: "hotspotoffice",
                sceneFadeDuration: 1000,
                autoRotate: -.7,
                setTimeout: 100,
                preview: this.poster
                
            },
            scenes: {
                hotspotoffice: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 0,
                    type: "equirectangular",
                    panorama: this.pvpanorama1,
                },
                anotherhotspot: {
                      hfov: 180,
                      pitch: 0,
                      yaw: 0,
                      type: "equirectangular",
                      panorama: this.pvpanorama2,
                  },
                  lasthotspot: {
                      hfov: 180,
                      pitch: 0,
                      yaw: 0,
                      type: "equirectangular",
                      panorama: this.pvpanorama3,
                  },
                
              }
          };
          pannellum.viewer('panorama', config);
        }
      })
      .catch((error) => {
          console.log(error)
        })
   //------------corpgovernance info---------------
   await axios.get('getsustenergyinfo/').then(
    response => {
        this.sustsec1text = response.data[0].edesc
        this.bottomtext = response.data[0].bottomtext
        // this.cpimg = response.data.cpimg
  })
  .catch((error) => {
      console.log(error)
    })

  //------------all highlights---------------
  await axios.get('getallhiglights/climatechange').then(
    response => {
        this.susthighlight = response.data[0].highlightdesc
  })
  .catch((error) => {
      console.log(error)
    })

 //------------sdgs mappings info---------------
 await axios.get('getsdgcmappings/climatechange').then(
    response => {
        this.sdgsmappingsinfo = response.data

  })
  .catch((error) => {
      console.log(error)
    })

  //------------breadcrumbs mappings info---------------
 await axios.get('getbreadcrumbsinfo/climatechange').then(
    response => {
        this.breadcrumbsinfo = response.data

  })
  .catch((error) => {
      console.log(error)
    })

   //------------sdgs Listing info---------------
 await axios.get('getsdgslistings/').then(
    response => {
        this.sdgslistinginfo = response.data
        // this.cpimg = response.data.cpimg
  })
  .catch((error) => {
      console.log(error)
    })

  //------------Get Reports---------------
  await axios.get('reportpresentationlisting/climatechange').then(
    response => {
      this.reportpresentation = response.data
      var reportcnt = parseInt(response.data[0].rpid)       

      axios.get(`reportpresentationsinglelisting/${reportcnt}`).then(
      response => {
        this.lastrecordsreportpresent = response.data
        this.rppdfpath = response.data.rppdfpath
        this.rptitle = response.data.rptitle
        this.rpdate = response.data.rpdate
        this.rplinkname = response.data.rplinkname
        this.rptfulltext = response.data.rptfulltext
        this.bgimage = response.data.bgimage
        this.rpcoverpageimagepath = response.data.rpcoverpageimagepath
        this.singlereporttitle = response.data.singlereporttitle
        this.rplinkname = response.data.rplinkname
        this.rpdate = response.data.rpdate
        this.showrpttext = response.data.showrptfulltext
        this.bgimage = response.data.bgimage
        this.showbg = response.data.showbgimage
      })
      .catch((error) => {
        console.log(error)
      })
            
    })
  .catch((error) => {
    console.log(error)
  })
  //------------Operations products page Cards ---------------
await axios.get('getgenericgraphdata/climatechange').then(
    response => { 
    this.opssilversupplygraphlabels = response.data.glabels
    this.opssilversupplygraphdata = response.data.gdata
    this.gcolorcodes = response.data.gcolorcodes
    

    const ctx = document.getElementById('myChart');
    const myChart = new Chart(ctx, {
    type: 'line',
    data: {
        labels: this.opssilversupplygraphlabels,
        datasets: [{
            label: 'Water Intensity',
            data: this.opssilversupplygraphdata,
            borderColor: this.gcolorcodes,
            fill: false,
            tension: 0.1
            // radius: 100,   
        }]
    },
    options: {
      animation:{
        animateRotate: true
      },
      // layout: {
      //       padding: 30
      //   },
      responsive: true,
      // aspectRatio: 1.4,
      plugins: {
        legend: {
          display: true,
            position: "bottom",
            align: "center"
          }
        }
    }
    });
    myChart;
 
  })
  .catch((error) => {
      console.log(error)
    }) 


}
}
</script>

<style scoped>
.section03 {
  height: 300px;
}
.container {
  display: grid;
  height: 100vh;;
  grid-template-columns: 1fr;
  grid-template-rows: .2fr 1.2fr .2fr;
  grid-template-areas: 
  "nav nav nav" 
  "main main main" 
  "footer footer footer";
  grid-gap: 0.2rem;
  font-family: "Inter", sans-serif;
  font-size: 800;
  font-size: 12px;
  color: #234234;
  text-align: center;
}

html { 
  height: 100%;
  margin:0px;
  background: url('../assets/slide-5.jpg') no-repeat center center;
  background-size: cover;
  background-attachment: fixed;
}

main {
  background: white;
  grid-area: main;
  padding-left: 0px;
  padding-right: 0px;
  margin-left: 0px;
  margin-right: 0px;
  border-radius: 0px;
  margin-top:-5px;
}
.formatrow {
  margin-top: 340px;
  padding-left: 100px;
  padding-right: 100px;
}
.seven3css {
  margin-top: 100px;
}

.reportpresentcss {
  margin-top: 300px;
}
.imagecss {
  width: 80%;
  padding-left: 50px;
  padding-bottom: 100px;
}
.pushsection {
  margin-top: -100px;
  background-color: white;
  padding: 30px;
}
.seven3css {
  width: 84%;
  margin: 0 auto;
  margin-top: 200px;
}
.carddivcss {
  margin-top: 30px;
}
.formatsdgs {
  padding-top: 20px;
  padding-bottom: 150px;
}

.videosection {
  margin-top: -60px;
  height: 600px;
  width: 100%;
  background-color: #003;
}

 .overlay {
  opacity: 0.99;
  width: 100%;
  height: 600px;
  background: linear-gradient(to bottom, #003, transparent);
  margin-top: -600px;

}

img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-color: #003;
}
@media only screen and (max-width: 600px) {
  .imagecss {
      width: 90%;
      margin: 0 auto;
      padding-bottom: 100px;
    }
    .formatsdgs {
      padding-right: 40px;
      padding-left: 40px;

    }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .imagecss {
      width: 90%;
      margin: 0 auto;
      padding-bottom: 100px;
    }
    .formatsdgs {
      padding-right: 100px;
      padding-left: 100px;

    }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .imagecss {
      width: 90%;
      margin: 0 auto;
      padding-bottom: 100px;
    }
}


/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .col-md-8 {
    margin-top: 100px;
  }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1400px) {
  .carddivcss {
    padding-left: 70px;
    padding-right: 70px;
  }
}

 /* Extra large devices (large laptops and desktops, 1200px and up) */
 @media only screen and (min-width: 1600px) {

}
</style>
